/** Formats a whole-minute duration compactly, e.g. 5 -> "5m", 60 -> "1h", 125 -> "2h 5m". */
export const formatMinutesCompact = (minutes: number): string => {
  if (minutes < 60) return `${minutes}m`
  const h = Math.floor(minutes / 60)
  const m = minutes % 60
  return m === 0 ? `${h}h` : `${h}h ${m}m`
}
